import React from "react";
import { formatDate } from "../../Utils/format-date.js";
import { addButton } from "../../Utils/addButtons";
import { addClassName } from "../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../Utils/calculate-progress.js";
import { Table } from "reactstrap";
import Emptyassessment from "../../Dashboard/My-assessments/empty-assessment";
import OpPopover from "../../Components/PopOver/Popover";
import info_black_24dp from "../../../images/info_black_24dp.png";
import Renderpopoverinnercontent from "../../Dashboard/My-assessments/popover-inner-content";
import completed from "../../../images/new-images/completed.png";
import './self-assessment-table.css'
import moment from "moment";
import { Row, Col, Collapse, CardBody } from "reactstrap";
import { LoaderComp } from "../../../_components/common/LoaderComp/Loadercomp.js";
const currentDate = moment().format("YYYY-MM-DD");

const Renderloitable = (props) => {
  const calcWidth = window.innerWidth;
  return (
    <React.Fragment>
     {props.userAssessmentDetails === undefined || props.userAssessmentDetails.length === 0 ? (
        <div className="loader-container">
          <LoaderComp color={'black'} />
        </div>
      ) : props.userAssessmentDetails.length === 0 ? (
        <Emptyassessment />
      ) : calcWidth > 768 ? (
        <Table>
          <thead>
            <tr>
              <th className="tableHeaders">Assessment Type</th>
              <th className="tableHeaders">Date Of Expiry</th>
              <th className="tableHeaders">Status</th>
              <th className="tableHeaders">Action</th>
            </tr>
          </thead>
          <tbody>
            {props.userAssessmentDetails.map((assessment, index) => {
              return (
                <tr key={index}>
                  <td>
                    <div className="assessmentType">
                      <img
                        className="assessmentIcon"
                        src={
                          localStorage.getItem("baseLink") +
                          `/media/` +
                          assessment.instrument__instrument_image
                        }
                      />
                      <div className="assessmentName">
                        {assessment.instrument__dashboard_header_text}
                      </div>
                      <OpPopover
                        positions={["right"]}
                        align={"center"}
                        targtElement={
                          <img className="infoIcon" src={info_black_24dp} />
                        }
                        isOpen={
                          props.isPopOverOpenAssessmentId === assessment.id
                        }
                        setOpen={(bool) => {
                          props.handleAssessmentPopOver(
                            bool ? assessment.id : false
                          );
                        }}
                      >
                        <Renderpopoverinnercontent
                          handleClosePopOver={props.handleClosePopOver}
                          assessmentheading={
                            assessment.instrument__dashboard_header_text
                          }
                          assesmentdescription={
                            assessment.instrument__dashboard_header_description
                          }
                        />
                      </OpPopover>
                    </div>
                    <div className="userName">
                      {assessment.participant__full_name}'s
                      <span>{assessment.instrument__instrument_name}</span>
                    </div>
                  </td>
                  <td>
                    <div className="Date">
                      {formatDate(assessment.expiry_date)}
                    </div>
                  </td>
                  <td>
                    {currentDate > assessment.expiry_date ? (
                      <div
                        className={
                          "assessment-status-text " +
                          addClassName(
                            assessment.assessment_status__status_name
                          )
                        }
                      >
                        Expired
                      </div>
                    ) : assessment.assessment_status__status_name ===
                      "Report in review" ? (
                      <div
                        className={
                          "assessment-status-text " +
                          addClassName(
                            assessment.assessment_status__status_name
                          )
                        }
                      >
                        Completed
                        <img src={completed} alt="Completed Image" />
                      </div>
                    ) : assessment.respondent_completed >=
                      assessment.batch__min_respondent ? (
                      <div
                        className={
                          "assessment-status-text " +
                          addClassName(
                            assessment.assessment_status__status_name
                          )
                        }
                      >
                        Completed
                        <span>
                          ({assessment.batch__min_respondent}/
                          {assessment.batch__min_respondent})
                        </span>
                      </div>
                    ) : assessment.assessment_status__status_name ===
                      "Yet to start" ? (
                      <div
                        className={
                          "assessment-status-text " +
                          addClassName(
                            assessment.assessment_status__status_name
                          )
                        }
                      >
                        {assessment.assessment_status__status_name}
                      </div>
                    ) : assessment.assessment_status__status_name ===
                      "In progress" ? (
                      <div
                        style={{ display: "flex" }}
                        className={
                          "assessment-status-text " +
                          addClassName(
                            assessment.assessment_status__status_name
                          )
                        }
                      >
                        {assessment.assessment_status__status_name}
                        {calcPercentage(
                          assessment.assessment_number_count,
                          assessment.assessment_completed_count
                        )}
                      </div>
                    ) : assessment.respondent_completed <
                      assessment.batch__min_respondent ? (
                      <div
                        className={
                          "assessment-status-text " +
                          addClassName(
                            assessment.assessment_status__status_name
                          )
                        }
                      >
                        Completed
                        <span>
                          ({assessment.respondent_completed}/
                          {assessment.batch__min_respondent})
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>{addButton(assessment)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <div className="Responsive-Assessment-Details">
          {props.userAssessmentDetails.map((assessment, index) => {
            return (
              <React.Fragment key={index}>
                <Row className="justify-content-around">
                  <img
                    className="assessmentIcon"
                    src={
                      localStorage.getItem("baseLink") +
                      `/media/` +
                      assessment.instrument__instrument_image
                    }
                  />
                  <div className="assessmentName mt-0">
                    {assessment.instrument__dashboard_header_text}
                    <p className="responsive-assessmentName">
                      {assessment.participant__full_name}'s{" "}
                      {assessment.instrument__instrument_name}
                    </p>
                  </div>
                  <OpPopover
                    positions={["left"]}
                    align={"center"}
                    targtElement={
                      <img className="infoIcon" src={info_black_24dp} />
                    }
                    isOpen={props.isPopOverOpenAssessmentId === assessment.id}
                    setOpen={(bool) => {
                      props.handleAssessmentPopOver(
                        bool ? assessment.id : false
                      );
                    }}
                  >
                    <Renderpopoverinnercontent
                      handleClosePopOver={props.handleClosePopOver}
                      assessmentheading={
                        assessment.instrument__dashboard_header_text
                      }
                      assesmentdescription={
                        assessment.instrument__dashboard_header_description
                      }
                    />
                  </OpPopover>
                  <i
                    onClick={() => props.toggleCollapse(assessment.id)}
                    className={
                      props.collapseID === assessment.id
                        ? "fas fa-angle-up align-self-center"
                        : "fa fa-angle-down align-self-center"
                    }
                    aria-hidden="true"
                  />
                </Row>

                <hr />
                <Collapse isOpen={props.collapseID === assessment.id}>
                  <CardBody>
                    <Row>
                      <Col className="title">Date of Expiry</Col>
                      <Col className="details">
                        {" "}
                        {formatDate(assessment.expiry_date)}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title">Status</Col>
                      <Col className="details">
                        {currentDate > assessment.expiry_date ? (
                          <div
                            className={
                              "assessment-status-text" +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            Expired
                          </div>
                        ) : assessment.assessment_status__status_name ===
                          "Report in review" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            Completed
                            <img src={completed} alt="Completed Image" />
                          </div>
                        ) : assessment.respondent_completed >=
                          assessment.batch__min_respondent ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            Completed
                            <span>
                              ({assessment.batch__min_respondent}/
                              {assessment.batch__min_respondent})
                            </span>
                          </div>
                        ) : assessment.assessment_status__status_name ===
                          "Yet to start" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                          </div>
                        ) : assessment.assessment_status__status_name ===
                          "In progress" ? (
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                            className={
                              "assessment-status-text assessment-status-text-inprogress " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                            {calcPercentage(
                              assessment.assessment_number_count,
                              assessment.assessment_completed_count
                            )}
                          </div>
                        ) : assessment.respondent_completed <
                          assessment.batch__min_respondent ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            Completed
                            <span>
                              ({assessment.respondent_completed}/
                              {assessment.respondent_count})
                            </span>
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>{addButton(assessment)}</Row>
                    <hr />
                  </CardBody>
                </Collapse>
              </React.Fragment>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};
export default Renderloitable;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/self-assessment-table.jsx